<template>
    <div class="sub-account-line-actions hidden space-x-2">
        <button v-if="params.data.isInvoiceLine && params.data.pendingTransactions.length == 0" title="Registrer betaling" @click="handleCreatePaymentTransaction">📝</button>
        <button :style="saccLineEmojiClass" :title="saccLineTooltip" @click="handleSaccLinesClicked">{{ saccLineEmoji }}</button>
    </div>
</template>

<script setup lang="ts">

import {computed, Ref} from 'vue'
import {SubAccountLine} from '@/subaccount/outstandingBalance/SubAccountLine'

const props = defineProps({
    params: {
        type: Object as () => {
            data: SubAccountLine,
            context: any,
            isCustomer: Boolean,
            isNotConnected: Function,
            rows: Ref<SubAccountLine[]>,
            handleSaccLinesClicked: (data: any) => void,
            handleCreatePaymentTransaction: (subAccountLine: SubAccountLine) => void
            handleCreateAutoPaymentTransaction: (subAccountLine: SubAccountLine) => void
        },
        required: true
    }
})

const saccLineEmojiClass = computed(() => saccLineEmoji.value === '❗' ? {cursor: 'default'} : {})

const handleSaccLinesClicked = () => props.params.handleSaccLinesClicked(props.params?.data)

const handleCreatePaymentTransaction = () => props.params.handleCreatePaymentTransaction(props.params?.data)

const saccLineEmoji = computed(() => {
    if (!props.params.data.isOpen) {
        return '🔒'
    } else if (props.params.data.remainingAmount !== props.params.data.amount) {
        return '🤏'
    } else if (props.params.isNotConnected(props.params.data) || props.params?.data?.pendingTransactions?.length > 0) {
        return '❗'
    } else if (props.params.rows.value?.some(row => row.remainingAmount === -props.params.data.remainingAmount)) {
        return '🪄'
    }
    return ''
})

const saccLineTooltip = computed(() => {
    if (!props.params.data.isOpen) {
        return 'Åpne post'
    } else if (props.params.data.remainingAmount !== props.params.data.amount) {
        return 'Åpne devlis lukket post'
    } else if (props.params.isNotConnected(props.params.data)) {
        return 'Post har ingen motpost'
    } else if (props.params.rows.value?.some(row => row.remainingAmount === -props.params.data.remainingAmount)) {
        return 'Lukk post mot match'
    } else if (props.params.data.pendingTransactions.length > 0) {
        // TODO link to pending transaction?
        return 'En betaling venter godkjenning for å lukke denne posten'
    } else {
        return 'Åpen post'
    }
})

</script>

<style scoped>
</style>